// @generated by protoc-gen-es v1.3.0
// @generated from file admin/v1/inventory.proto (package admin.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { ListMetadata } from "./types/v1/list_metadata_pb.js";
import { Domain, Owner } from "./types/v1/domain_pb.js";

/**
 * @generated from message admin.v1.GetInventoryFlatOldRequest
 */
export const GetInventoryFlatOldRequest = proto3.makeMessageType(
  "admin.v1.GetInventoryFlatOldRequest",
  [],
);

/**
 * @generated from message admin.v1.ColumnOld
 */
export const ColumnOld = proto3.makeMessageType(
  "admin.v1.ColumnOld",
  () => [
    { no: 1, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "datastore_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "table_physical_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "table_attribute_number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "alias", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "table_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "data_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "data_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "data_type_oid", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 14, name: "data_label_locked_for_sidecar", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "encrypted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryFlatOldResponse
 */
export const GetInventoryFlatOldResponse = proto3.makeMessageType(
  "admin.v1.GetInventoryFlatOldResponse",
  () => [
    { no: 1, name: "inventory", kind: "message", T: ColumnOld, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.UpdateColumnFieldEncryptionRequest
 */
export const UpdateColumnFieldEncryptionRequest = proto3.makeMessageType(
  "admin.v1.UpdateColumnFieldEncryptionRequest",
  () => [
    { no: 1, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "encryption_key_storage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "encryption_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "encryption_algorithm", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "encrypt_existing_data", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message admin.v1.UpdateColumnFieldEncryptionResponse
 */
export const UpdateColumnFieldEncryptionResponse = proto3.makeMessageType(
  "admin.v1.UpdateColumnFieldEncryptionResponse",
  [],
);

/**
 * @generated from message admin.v1.GetInventoryObjectRequest
 */
export const GetInventoryObjectRequest = proto3.makeMessageType(
  "admin.v1.GetInventoryObjectRequest",
  () => [
    { no: 1, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryObjectResponse
 */
export const GetInventoryObjectResponse = proto3.makeMessageType(
  "admin.v1.GetInventoryObjectResponse",
  () => [
    { no: 1, name: "column", kind: "message", T: Column },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryHierarchicalRequest
 */
export const GetInventoryHierarchicalRequest = proto3.makeMessageType(
  "admin.v1.GetInventoryHierarchicalRequest",
  [],
);

/**
 * @generated from message admin.v1.GetInventoryHierarchicalResponse
 */
export const GetInventoryHierarchicalResponse = proto3.makeMessageType(
  "admin.v1.GetInventoryHierarchicalResponse",
  () => [
    { no: 1, name: "inventory", kind: "message", T: GetInventoryHierarchicalResponse_Datastore, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryHierarchicalResponse.Datastore
 */
export const GetInventoryHierarchicalResponse_Datastore = proto3.makeMessageType(
  "admin.v1.GetInventoryHierarchicalResponse.Datastore",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "technology", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "dbs", kind: "message", T: GetInventoryHierarchicalResponse_Db, repeated: true },
  ],
  {localName: "GetInventoryHierarchicalResponse_Datastore"},
);

/**
 * @generated from message admin.v1.GetInventoryHierarchicalResponse.Db
 */
export const GetInventoryHierarchicalResponse_Db = proto3.makeMessageType(
  "admin.v1.GetInventoryHierarchicalResponse.Db",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "schemas", kind: "message", T: GetInventoryHierarchicalResponse_Schema, repeated: true },
    { no: 5, name: "tables", kind: "message", T: GetInventoryHierarchicalResponse_Table, repeated: true },
  ],
  {localName: "GetInventoryHierarchicalResponse_Db"},
);

/**
 * @generated from message admin.v1.GetInventoryHierarchicalResponse.Schema
 */
export const GetInventoryHierarchicalResponse_Schema = proto3.makeMessageType(
  "admin.v1.GetInventoryHierarchicalResponse.Schema",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "db_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tables", kind: "message", T: GetInventoryHierarchicalResponse_Table, repeated: true },
  ],
  {localName: "GetInventoryHierarchicalResponse_Schema"},
);

/**
 * @generated from message admin.v1.GetInventoryHierarchicalResponse.Table
 */
export const GetInventoryHierarchicalResponse_Table = proto3.makeMessageType(
  "admin.v1.GetInventoryHierarchicalResponse.Table",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "db_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "schema_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "columns", kind: "message", T: GetInventoryHierarchicalResponse_Column, repeated: true },
  ],
  {localName: "GetInventoryHierarchicalResponse_Table"},
);

/**
 * @generated from message admin.v1.GetInventoryHierarchicalResponse.Column
 */
export const GetInventoryHierarchicalResponse_Column = proto3.makeMessageType(
  "admin.v1.GetInventoryHierarchicalResponse.Column",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "table_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "GetInventoryHierarchicalResponse_Column"},
);

/**
 * @generated from message admin.v1.GetInventoryRequest
 */
export const GetInventoryRequest = proto3.makeMessageType(
  "admin.v1.GetInventoryRequest",
  () => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "excluded_paths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "included_objects", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryResponse
 */
export const GetInventoryResponse = proto3.makeMessageType(
  "admin.v1.GetInventoryResponse",
  () => [
    { no: 1, name: "inventory", kind: "message", T: InventoryObject, repeated: true },
    { no: 2, name: "list_metadata", kind: "message", T: ListMetadata },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryFlatRequest
 */
export const GetInventoryFlatRequest = proto3.makeMessageType(
  "admin.v1.GetInventoryFlatRequest",
  () => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "after", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "before", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.Column
 */
export const Column = proto3.makeMessageType(
  "admin.v1.Column",
  () => [
    { no: 1, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "datastore_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "table_physical_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "table_attribute_number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "alias", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "table_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "data_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "data_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "data_type_oid", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 14, name: "data_label_locked_for_sidecar", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "encrypted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.Ds
 */
export const Ds = proto3.makeMessageType(
  "admin.v1.Ds",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "technology", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "dbs", kind: "message", T: Db, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.Db
 */
export const Db = proto3.makeMessageType(
  "admin.v1.Db",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "schemas", kind: "message", T: Schema, repeated: true },
    { no: 5, name: "tables", kind: "message", T: Table, repeated: true },
    { no: 6, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.Schema
 */
export const Schema = proto3.makeMessageType(
  "admin.v1.Schema",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "db_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tables", kind: "message", T: Table, repeated: true },
    { no: 5, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.Table
 */
export const Table = proto3.makeMessageType(
  "admin.v1.Table",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "db_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "schema_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "columns", kind: "message", T: Column, repeated: true },
    { no: 6, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.SubColumn
 */
export const SubColumn = proto3.makeMessageType(
  "admin.v1.SubColumn",
  () => [
    { no: 1, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "datastore_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "table_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "data_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "data_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "data_type_oid", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 14, name: "data_label_locked_for_sidecar", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "encrypted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.InventoryObject
 */
export const InventoryObject = proto3.makeMessageType(
  "admin.v1.InventoryObject",
  () => [
    { no: 1, name: "datastore", kind: "message", T: Ds, oneof: "object" },
    { no: 2, name: "db", kind: "message", T: Db, oneof: "object" },
    { no: 3, name: "schema", kind: "message", T: Schema, oneof: "object" },
    { no: 4, name: "table", kind: "message", T: Table, oneof: "object" },
    { no: 5, name: "column", kind: "message", T: Column, oneof: "object" },
    { no: 6, name: "sub_column", kind: "message", T: SubColumn, oneof: "object" },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryFlatResponse
 */
export const GetInventoryFlatResponse = proto3.makeMessageType(
  "admin.v1.GetInventoryFlatResponse",
  () => [
    { no: 1, name: "inventory", kind: "message", T: InventoryObject, repeated: true },
    { no: 2, name: "list_metadata", kind: "message", T: ListMetadata },
  ],
);

/**
 * @generated from message admin.v1.UpdateColumnLockStatusRequest
 */
export const UpdateColumnLockStatusRequest = proto3.makeMessageType(
  "admin.v1.UpdateColumnLockStatusRequest",
  () => [
    { no: 1, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "validated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message admin.v1.UpdateColumnLockStatusResponse
 */
export const UpdateColumnLockStatusResponse = proto3.makeMessageType(
  "admin.v1.UpdateColumnLockStatusResponse",
  [],
);

/**
 * @generated from message admin.v1.UpdateColumnDataLabelRequest
 */
export const UpdateColumnDataLabelRequest = proto3.makeMessageType(
  "admin.v1.UpdateColumnDataLabelRequest",
  () => [
    { no: 1, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.UpdateColumnDataLabelResponse
 */
export const UpdateColumnDataLabelResponse = proto3.makeMessageType(
  "admin.v1.UpdateColumnDataLabelResponse",
  [],
);

/**
 * @generated from message admin.v1.CreateInventoryObjectRequest
 */
export const CreateInventoryObjectRequest = proto3.makeMessageType(
  "admin.v1.CreateInventoryObjectRequest",
  () => [
    { no: 1, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "object_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "db", kind: "message", T: CreateInventoryObjectRequest_Db },
    { no: 4, name: "schema", kind: "message", T: CreateInventoryObjectRequest_Schema },
    { no: 5, name: "table", kind: "message", T: CreateInventoryObjectRequest_Table },
    { no: 6, name: "column", kind: "message", T: CreateInventoryObjectRequest_Column },
    { no: 7, name: "sub_column", kind: "message", T: CreateInventoryObjectRequest_SubColumn },
  ],
);

/**
 * @generated from message admin.v1.CreateInventoryObjectRequest.Db
 */
export const CreateInventoryObjectRequest_Db = proto3.makeMessageType(
  "admin.v1.CreateInventoryObjectRequest.Db",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CreateInventoryObjectRequest_Db"},
);

/**
 * @generated from message admin.v1.CreateInventoryObjectRequest.Schema
 */
export const CreateInventoryObjectRequest_Schema = proto3.makeMessageType(
  "admin.v1.CreateInventoryObjectRequest.Schema",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CreateInventoryObjectRequest_Schema"},
);

/**
 * @generated from message admin.v1.CreateInventoryObjectRequest.Table
 */
export const CreateInventoryObjectRequest_Table = proto3.makeMessageType(
  "admin.v1.CreateInventoryObjectRequest.Table",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CreateInventoryObjectRequest_Table"},
);

/**
 * @generated from message admin.v1.CreateInventoryObjectRequest.Column
 */
export const CreateInventoryObjectRequest_Column = proto3.makeMessageType(
  "admin.v1.CreateInventoryObjectRequest.Column",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CreateInventoryObjectRequest_Column"},
);

/**
 * @generated from message admin.v1.CreateInventoryObjectRequest.SubColumn
 */
export const CreateInventoryObjectRequest_SubColumn = proto3.makeMessageType(
  "admin.v1.CreateInventoryObjectRequest.SubColumn",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sub_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CreateInventoryObjectRequest_SubColumn"},
);

/**
 * @generated from message admin.v1.CreateInventoryObjectResponse
 */
export const CreateInventoryObjectResponse = proto3.makeMessageType(
  "admin.v1.CreateInventoryObjectResponse",
  [],
);

/**
 * @generated from message admin.v1.DeleteInventoryObjectRequest
 */
export const DeleteInventoryObjectRequest = proto3.makeMessageType(
  "admin.v1.DeleteInventoryObjectRequest",
  () => [
    { no: 1, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.DeleteInventoryObjectResponse
 */
export const DeleteInventoryObjectResponse = proto3.makeMessageType(
  "admin.v1.DeleteInventoryObjectResponse",
  [],
);

/**
 * @generated from message admin.v1.Tag
 */
export const Tag = proto3.makeMessageType(
  "admin.v1.Tag",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message admin.v1.CreateInventoryTagRequest
 */
export const CreateInventoryTagRequest = proto3.makeMessageType(
  "admin.v1.CreateInventoryTagRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.CreateInventoryTagResponse
 */
export const CreateInventoryTagResponse = proto3.makeMessageType(
  "admin.v1.CreateInventoryTagResponse",
  () => [
    { no: 1, name: "tag", kind: "message", T: Tag },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryTagsRequest
 */
export const GetInventoryTagsRequest = proto3.makeMessageType(
  "admin.v1.GetInventoryTagsRequest",
  () => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "after", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "before", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetInventoryTagsResponse
 */
export const GetInventoryTagsResponse = proto3.makeMessageType(
  "admin.v1.GetInventoryTagsResponse",
  () => [
    { no: 1, name: "tags", kind: "message", T: Tag, repeated: true },
    { no: 2, name: "list_metadata", kind: "message", T: ListMetadata },
  ],
);

/**
 * @generated from message admin.v1.UpdateInventoryObjectTagsRequest
 */
export const UpdateInventoryObjectTagsRequest = proto3.makeMessageType(
  "admin.v1.UpdateInventoryObjectTagsRequest",
  () => [
    { no: 1, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.UpdateInventoryObjectTagsResponse
 */
export const UpdateInventoryObjectTagsResponse = proto3.makeMessageType(
  "admin.v1.UpdateInventoryObjectTagsResponse",
  () => [
    { no: 1, name: "object", kind: "message", T: UpdateInventoryObjectTagsResponse_InventoryObject },
  ],
);

/**
 * @generated from message admin.v1.UpdateInventoryObjectTagsResponse.InventoryObject
 */
export const UpdateInventoryObjectTagsResponse_InventoryObject = proto3.makeMessageType(
  "admin.v1.UpdateInventoryObjectTagsResponse.InventoryObject",
  () => [
    { no: 1, name: "datastore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "db_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "table_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "schema_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "table_attribute_number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "data_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "data_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "data_store_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "validated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
  {localName: "UpdateInventoryObjectTagsResponse_InventoryObject"},
);

/**
 * Delete
 *
 * @generated from message admin.v1.DeleteInventoryTagRequest
 */
export const DeleteInventoryTagRequest = proto3.makeMessageType(
  "admin.v1.DeleteInventoryTagRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.DeleteInventoryTagResponse
 */
export const DeleteInventoryTagResponse = proto3.makeMessageType(
  "admin.v1.DeleteInventoryTagResponse",
  () => [
    { no: 1, name: "tags", kind: "message", T: Tag, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.CreateDataDomainRequest
 */
export const CreateDataDomainRequest = proto3.makeMessageType(
  "admin.v1.CreateDataDomainRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "owners", kind: "message", T: Owner, repeated: true },
    { no: 4, name: "excluded_paths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "included_paths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.CreateDataDomainResponse
 */
export const CreateDataDomainResponse = proto3.makeMessageType(
  "admin.v1.CreateDataDomainResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetDataDomainsRequest
 */
export const GetDataDomainsRequest = proto3.makeMessageType(
  "admin.v1.GetDataDomainsRequest",
  [],
);

/**
 * @generated from message admin.v1.GetDataDomainsResponse
 */
export const GetDataDomainsResponse = proto3.makeMessageType(
  "admin.v1.GetDataDomainsResponse",
  () => [
    { no: 1, name: "domains", kind: "message", T: Domain, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.GetDataDomainByIdRequest
 */
export const GetDataDomainByIdRequest = proto3.makeMessageType(
  "admin.v1.GetDataDomainByIdRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetDataDomainByIdResponse
 */
export const GetDataDomainByIdResponse = proto3.makeMessageType(
  "admin.v1.GetDataDomainByIdResponse",
  () => [
    { no: 1, name: "domain", kind: "message", T: Domain },
  ],
);

/**
 * @generated from message admin.v1.UpdateDataDomainRequest
 */
export const UpdateDataDomainRequest = proto3.makeMessageType(
  "admin.v1.UpdateDataDomainRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "owners", kind: "message", T: Owner, repeated: true },
    { no: 5, name: "excluded_paths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "included_paths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.UpdateDataDomainResponse
 */
export const UpdateDataDomainResponse = proto3.makeMessageType(
  "admin.v1.UpdateDataDomainResponse",
  () => [
    { no: 1, name: "domain", kind: "message", T: Domain },
  ],
);

/**
 * @generated from message admin.v1.DeleteDataDomainRequest
 */
export const DeleteDataDomainRequest = proto3.makeMessageType(
  "admin.v1.DeleteDataDomainRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.DeleteDataDomainResponse
 */
export const DeleteDataDomainResponse = proto3.makeMessageType(
  "admin.v1.DeleteDataDomainResponse",
  [],
);

